import { Injectable } from '@angular/core';
import { MyTripFormData } from '@com-delta-idp/mnx-capability-trip-management-ui';
import { APP_NAME } from '../models/enums/my-trip.enums';
import { PaymentReferenceService } from '../services/payment-reference.service';
import { CreditCardFacade } from './credit-card.facade';
import { MyTripFacade } from './my-trip.facade';

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {
  constructor(
    private ccFacade: CreditCardFacade,
    private paymentService: PaymentReferenceService,
    private facade: MyTripFacade
  ) {}

  getCardReferenceId(formData: MyTripFormData): void {
    if (formData.cardNo) {
      this.paymentService.getCardReferenceId(formData.cardNo ?? '').subscribe(
        (reference) =>
          this.ccFacade.getList({
            referenceId: reference.paymentReferenceId,
            fName: formData.firstName,
            lName: formData.lastName,
            app: APP_NAME
          }),
        () => {
          this.facade.spinner.set(false);
          this.facade.displayErrorMessage.set(true);
        }
      );
    }
  }
}
